export type EquipVia = 'tap' | 'drag';

export type EquipKeyframe = {
  durationMs: number;
  scale: number;
  angle: number;
  offsetX: number;
  offsetY: number;
  applyOutfit: boolean;
};

export type EquipJuicePlan = {
  keyframes: EquipKeyframe[];
};

/** One visual item flies to its slot; the outfit settles exactly once. */
export function equipJuicePlan(
  via: EquipVia,
  reducedMotion: boolean,
): EquipJuicePlan {
  if (reducedMotion) {
    return {
      keyframes: [
        {
          durationMs: 0,
          scale: 1,
          angle: 0,
          offsetX: 0,
          offsetY: 0,
          applyOutfit: true,
        },
      ],
    };
  }

  const direction = via === 'drag' ? 1 : -1;
  return {
    keyframes: [
      {
        durationMs: 110,
        scale: 1.12,
        angle: 9 * direction,
        offsetX: 12 * direction,
        offsetY: -18,
        applyOutfit: false,
      },
      {
        durationMs: 150,
        scale: 0.92,
        angle: -5 * direction,
        offsetX: 0,
        offsetY: 0,
        applyOutfit: false,
      },
      {
        durationMs: 120,
        scale: 1,
        angle: 0,
        offsetX: 0,
        offsetY: 0,
        applyOutfit: true,
      },
    ],
  };
}
